import { render, staticRenderFns } from "./EbookLearn.vue?vue&type=template&id=3e8684ae&scoped=true&"
import script from "./EbookLearn.vue?vue&type=script&lang=js&"
export * from "./EbookLearn.vue?vue&type=script&lang=js&"
import style0 from "./EbookLearn.vue?vue&type=style&index=0&id=3e8684ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8684ae",
  null
  
)

export default component.exports